export class Vehicle {
  constructor(data) {
    Object.assign(this, data);
  }
}
